import React, { useEffect } from 'react'
import useSWR from 'swr'
import Fetcher from '@lib/fetcher'
import { ArrowPathIcon, XMarkIcon } from '@heroicons/react/24/outline'
import InstanceSeating from './seating'
import TicketType from './ticket-type'
import useCustomModel from './model'

const InstanceBasket = ({ instance, event, onClose, inBasket, mutate }) => {
  const model = useCustomModel(
    `instances-${instance.spektrix_v3_id || instance.id}`
  )({
    event: event,
    instance: instance
  })
  const { data: plan } = useSWR(
    `/instances/${instance.spektrix_v3_id || instance.id}/plan`,
    Fetcher
  )

  useEffect(() => {
    if (plan) {
      model.plan = { ...plan }
    }
  }, [plan])

  useEffect(() => {
    if (inBasket) {
      model.currentBasket = inBasket
    }
  }, [inBasket])

  useEffect(() => {
    if (model.unreservedSeating || model.groupUnreservedSeating) {
      model.showTicketTypes = true
    }
  }, [model.plan])

  if (!model.plan) {
    return (
      <div className='w-full flex items-center justify-center space-x-1'>
        <ArrowPathIcon className='w-4 h-4 text-gray-500 dark:text-gray-400 animate-spin' />
        <span className='text-gray-700 dark:text-gray-300'>
          loading plan for {model.event?.name}
        </span>
      </div>
    )
  }

  return (
    <div className='flex flex-col w-full'>
      <div className={model.reservedSeating ? 'flex flex-col' : 'flex justify-center h-full'}>
        {model.showTicketTypes ? (
          <TicketType
            onClose={onClose}
            inBasket={inBasket}
            model={model}
            instance={instance}
            mutate={mutate}
          />
        ) : (
          <InstanceSeating
            instance={instance}
            model={model}
            onClose={onClose}
          />
        )}
      </div>
    </div>
  )
}

export default InstanceBasket
